import React from "react";
import styled from "styled-components";
import tick from "../../../../../images/icon-tick.svg";

const Background = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 3px;
    background-color: #9b9b9b;
`;

const Checkbox = ({className, checked, onClick}) => {
    const icon = checked ? <img className="t-checked-icon" src={tick}/> : null;
    return (
        <Background className={className} onClick={onClick}>{icon}</Background>
    );
};

export default Checkbox;